import { Serializable } from './serializable';

//There are three more standard patch operations (move, copy, and test), but we
//won't be using them
enum PatchOperation {
	Add = 'add',
	Remove = 'remove',
	Replace = 'replace'
}

export interface PatchCommand {
	op:PatchOperation;
	path:string;
	value?:any;
}

export abstract class Patchable<T> extends Serializable<T> {
	public getPatchCommands():PatchCommand[] {
		let patchArray = [];
		compareObjects(this.source, this.toApi(), patchArray);
		return patchArray;
	}
}

//Main functionality taken from https://www.npmjs.com/package/fast-json-patch
//Recursively traverses the objects to compare properties and add to the array of patch commands
function compareObjects(originalObject, alteredObject, patches:PatchCommand[], path = '') {
	if (alteredObject === originalObject) {
		return;
	}
  
	if (typeof alteredObject.toJSON === 'function') {
		alteredObject = alteredObject.toJSON();
	}
  
	let alteredObjectKeys = Object.keys(alteredObject);
	let originalObjectKeys = Object.keys(originalObject);
	let hasRemovedProperty = false;
  
	for (var keyIndex = originalObjectKeys.length - 1; keyIndex >= 0; keyIndex--) {
		let key = originalObjectKeys[keyIndex];
		let originalVal = originalObject[key];

		if (alteredObject.hasOwnProperty(key) && !(alteredObject[key] === undefined && originalVal !== undefined && Array.isArray(alteredObject) === false)) {
			var alteredVal = alteredObject[key];
			if (typeof originalVal == 'object' && originalVal != null && typeof alteredVal == 'object' && alteredVal != null) {
				compareObjects(originalVal, alteredVal, patches, path + "/" + escapePathComponent(key));
			}
			else {
				if (originalVal !== alteredVal) {
					patches.push({ op: PatchOperation.Replace, path: path + "/" + escapePathComponent(key), value: angular.copy(alteredVal) });
				}
			}
		}
		else {
			patches.push({ op: PatchOperation.Remove, path: path + "/" + escapePathComponent(key) });
			hasRemovedProperty = true;
		}
	}
  
	if (!hasRemovedProperty && alteredObjectKeys.length == originalObjectKeys.length) {
		return;
	}
  
	for (let keyIndex = 0; keyIndex < alteredObjectKeys.length; keyIndex++) {
	  	let key = alteredObjectKeys[keyIndex];
	  	if (!originalObject.hasOwnProperty(key) && alteredObject[key] !== undefined) {
			// You'd typically use '..."/" + escapePathComponent(key)' here, but adding to the end of arrays instead of inserting
			// based on index works better for us (especially considering permission arrays)
			patches.push({ op: PatchOperation.Add, path: path + "/" + '-', value: angular.copy(alteredObject[key]) });
		}
	}
}

/**
* Escapes a json pointer path
* @param path The raw pointer
* @return the Escaped path
*/
function escapePathComponent(path:string): string {
    if (path.indexOf('/') === -1 && path.indexOf('~') === -1) return path;
    return path.replace(/~/g, '~0').replace(/\//g, '~1');
}


// WEBPACK FOOTER //
// ./src/util/domain/patchable.ts